export interface TagData {
  type: string;
  id: string;
  label: string;
}

/**
 * Estrae gli attributi da un elemento mention tag
 */
const extractTagAttributes = (element: HTMLElement): string => {
  const type = element.getAttribute('data-tag-type') ?? '';
  const id = element.getAttribute('data-tag-id') ?? '';
  const label = element.getAttribute('data-tag-label') ?? '';
  return `{${type}:${label}, id:${id}}`;
};

/**
 * Verifica se un nodo è un elemento mention tag
 */
const isMentionTag = (node: Node): node is HTMLElement => {
  return (
    node.nodeType === Node.ELEMENT_NODE &&
    (node as HTMLElement).hasAttribute('data-tag-type')
  );
};

/**
 * Estrae il testo da un nodo di testo
 */
const extractTextContent = (node: Node): string => {
  return node.nodeType === Node.TEXT_NODE ? (node.textContent ?? '') : '';
};

/**
 * Processa ricorsivamente un nodo e i suoi figli
 */
const processNode = (node: Node): string => {
  if (isMentionTag(node)) {
    return extractTagAttributes(node);
  }

  if (node.nodeType === Node.TEXT_NODE) {
    return extractTextContent(node);
  }

  if (node.nodeType === Node.ELEMENT_NODE) {
    return Array.from(node.childNodes).map(processNode).join('');
  }

  return '';
};

/**
 * Converte HTML content in formato testuale {type:label, id:id}
 */
export const htmlToTextFormat = (html: string): string => {
  if (!html || html.trim() === '') {
    return '';
  }

  const container = document.createElement('div');
  container.innerHTML = html;

  return Array.from(container.childNodes).map(processNode).join('').trim();
};
